export default __webpack_public_path__ + "static/media/cell_shader.45f58a59.PNG";